import { correlativeApi } from "../../api";

const CorrelativeService = {
  getForPurchase: async (documentTypeId: number) => {
    const response = await correlativeApi.fetchCustom(`/purchase/correlative?documentTypeId=${documentTypeId}`);
    return response.data;
  },

  /**
   * 🔢 Genera u obtiene un correlativo para una sucursal y tipo de documento
   * GET /api/document-correlatives/generate
   */
  generate: async (
    branchId: number,
    documentTypeId: number,
    correlativeId?: number
  ) => {
    let url = `/generate?branchId=${branchId}&documentTypeId=${documentTypeId}`;

    if (correlativeId) {
      url += `&correlativeId=${correlativeId}`;
    }

    const response = await correlativeApi.fetchCustom(url);
    return response.data;
  }


};

export default CorrelativeService;
